import { render } from "./App.vue?vue&type=template&id=48cbb31c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=48cbb31c&lang=css"

import exportComponent from "C:\\Users\\Szymon\\witryny\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__